<template>
  <nuxt-link :to="challengeUrl">
    <div class="challenge-link">
      <img :src="challengePhotoUrl" />
      <avatar :user="challengeOwner" />
      <challenge-icon :challenge="challenge" />
    </div>
  </nuxt-link>
</template>

<script>
  import './ChallengeLink.scss';
  import { imageToSize } from '~/utils/imageUtilFrontend';
  import { challengeToUrl } from '~/utils/pqUtil';
  import Avatar from '~/components/Avatar';
  import ChallengeIcon from '~/components/ChallengeIcon';

  export default {
    props: ['challenge'],
    components: {
      Avatar,
      ChallengeIcon
    },
    computed: {
      challengeOwner() {
        return this.challenge ? this.challenge.owner : undefined;
      },
      challengeUrl() {
        console.log(this.challenge);
        return challengeToUrl(this.challenge);
      },
      challengePhotoUrl() {
        if (!this.challenge.photos || !this.challenge.photos.length) {
          return '';
        }
        return imageToSize(this.challenge.photos[0], 'small');
      }
    }
  };
</script>
